const meta = {
  module: "packing-categories"
};

export default [
  {
    path: `/packing-categories`,
    redirect: "/packing-categories/page/1"
  },
  {
    path: `/packing-categories/page`,
    redirect: "/packing-categories/page/1"
  },
  {
    path: `/packing-categories/page/:page`,
    name: "packing-categries",
    component: () =>
      import(
        /* webpackChunkName: "packing-categries" */ "@/modules/packing-categries/views/index.vue"
      ),
    meta: {
      ...meta
    }
  },
  {
    path: `/packing-categories/create`,
    name: "packing-categries/create",
    component: () =>
      import(
        /* webpackChunkName: "packing-categries/create" */ "@/modules/packing-categries/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create"
    }
  },
  {
    path: `/packing-categories/edit/:id`,
    name: "packing-categries/edit",
    component: () =>
      import(
        /* webpackChunkName: "packing-categries/edit" */ "@/modules/packing-categries/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit"
    }
  }
];
